import parser from './parser';

const name = 'timePicker';


export default {parser, name};
